import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';
import { EventCentreDialogState } from '../event-centre-dialog.state';
import { filterItems } from '../function/filter-items.function';

import { SelectCategory } from './select-category.action';

export function selectCategoryReducer(
    state: EventCentreDialogState,
    action: PayloadAction<ActionType.NOTI__EC__SELECT_CATEGORY, SelectCategory>,
): EventCentreDialogState {
    try {
        const nextCat = state.categories?.find(
            (e) => e.categoryId === action.payload.categoryId,
        );

        const nextFilt = filterItems({
            items: state.items,
            categoryId: nextCat?.categoryId,
            filterOpts: state.filterOpts,
            categories: state.categories,
            orderBy: state.orderBy,
        });

        return {
            ...state,
            categoryId: nextCat?.categoryId,
            category: nextCat,
            filteredItems: nextFilt,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
